"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOneRoute = void 0;
exports.getOneRoute = '/queue/';
//# sourceMappingURL=getOne.route.js.map